<template>
  <div class="grid grid-cols-1 mx-5 my-5 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-3 gap-6">
    <BoardCard title="Логи">
      <Bar
          id="my-chart-id"
          :options="chartOptions"
          :data="logChartData"/>
    </BoardCard>
    <CountByLevelAndDate/>
    <SizeStat/>
    <ErrorStat/>

    <BoardCard title="Статстика использования">
      <p class="text-gray-600 mb-2">Записай: 1254</p>
      <p class="text-gray-600 mb-2">Размер: 12.5 / 100 Mb</p>
      <p class="text-gray-600 mb-2">Хранение: 3 дня</p>
    </BoardCard>
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs'
import { Chart as ChartJS, Title, PointElement, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
import BoardCard from "@/components/BoardCard.vue";
import ErrorStat from "@/components/dashboard/ErrorStat.vue";
import SizeStat from "@/components/dashboard/SizeStat.vue";
import CountByLevelAndDate from "@/components/dashboard/CountByLevelAndDate.vue";

ChartJS.register(Title, PointElement, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  name: 'HomePage',
  components: {BoardCard, Bar, SizeStat, CountByLevelAndDate, ErrorStat},
  data() {
    return {
      logChartData: {
        labels: [ '21.05', '22.05', '23.05', '24.05', '25.05' ],
        datasets: [ {
          label: 'Data One',
          backgroundColor: '#f87979',
          data: [2,15,45, 20, 12]
        },
          {
            label: 'Data Two',
            backgroundColor: '#007979',
            data: [0,1,5, 3, 1]
          }]
      },
      chartOptions: {
        responsive: true
      }
    }
  }
}
</script>

<style scoped>

</style>